import { render, staticRenderFns } from "./ModelConfig.vue?vue&type=template&id=65a6272c&scoped=true"
import script from "./ModelConfig.vue?vue&type=script&lang=js"
export * from "./ModelConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelConfig.vue?vue&type=style&index=0&id=65a6272c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6272c",
  null
  
)

export default component.exports